
    /**
     * Clamps value inside range.
     */
    function clamp(val, min, max){
        return val < min? min : (val > max? max : val);
    }
    module.exports = clamp;




//////////////////
// WEBPACK FOOTER
// ./~/mout/math/clamp.js
// module id = 700
// module chunks = 0 1 2